import React, {useState} from 'react';
import RequestDemoModal from "./RequestDemoModal";
import ReactGA from "react-ga4";
import { isMobile } from 'react-device-detect';
import { ITopBanner } from '../../Interfaces/shared';
import { Link } from "gatsby"; 

const TopBanner = ({
  title, 
  description, 
  image, 
  isRequestDemoVisible, 
  contactButtonLink, 
  altText, 
  eventAction, 
  eventLabel
}: ITopBanner) => {
    
  // STATES
  const [isModalOpen, setIsModalOpen] = useState(false);
  const toggleModal = () => setIsModalOpen(!isModalOpen);

  const normalizedContent = Array.isArray(description) ? description.join(", ") : description;

  const handleButtonEvent = () => {
    ReactGA.event({
      category: 'Button',
      action: eventAction,
      label: eventLabel,
    });
    
    setIsModalOpen(true);
  }

  return <React.Fragment>
    <div className="top-banner">
      <div className="container d-flex align-items-start">
        <div className="description-wrapper">
          <div className="title mb-4">{title}</div>
          {description && <div className="description mb-5" dangerouslySetInnerHTML={{ __html: normalizedContent }} />}
          {isRequestDemoVisible && <button onClick={handleButtonEvent} className="btn btn-sm btn btn-sm btn-primary">Request Demo</button>}
          {contactButtonLink && (
            <Link
              to={contactButtonLink.url}
              onClick={() => {
                ReactGA.event({
                  category: 'Button',
                  action: eventAction,
                  label: eventLabel,
                });
              }}
              className="btn btn-sm btn-primary"
            >
              Contact us
            </Link>
          )}
        </div>
        <img className="image" src={isMobile ? image.mobile : image.desktop} alt={altText} />
      </div>
    </div>
    <RequestDemoModal isOpen={isModalOpen} toggle={toggleModal} closeModal={() => setIsModalOpen(false)} />
  </React.Fragment>
}

export default TopBanner;